import { useEffect, useRef, useState } from "react";
import { resolveMediaUrl } from "@/lib/mediaUrl";

export const DEFAULT_ABOUT_VIDEO = "/videos/about-section.mp4";
/** Placeholder bundled with the static build — replace public/videos/about-section.mp4 when a final cut is ready. */

export function resolveAboutVideoUrl(cmsUrl) {
  const resolved = resolveMediaUrl(cmsUrl);
  return resolved || DEFAULT_ABOUT_VIDEO;
}

/** Muted autoplay with in-view play + reload when CMS src changes. */
export function useAboutSectionVideo(src) {
  const videoRef = useRef(null);
  const wrapRef = useRef(null);
  const [videoMuted, setVideoMuted] = useState(true);
  const [videoFailed, setVideoFailed] = useState(false);

  useEffect(() => {
    setVideoFailed(false);
  }, [src]);

  useEffect(() => {
    const node = wrapRef.current;
    const video = videoRef.current;
    if (!node || !video) return undefined;

    const tryPlay = () => {
      video.play().catch(() => {});
    };

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) tryPlay();
        else video.pause();
      },
      { threshold: 0.25 },
    );

    observer.observe(node);
    tryPlay();

    return () => observer.disconnect();
  }, [src, videoFailed]);

  const toggleVideoSound = () => {
    setVideoMuted((prev) => {
      const next = !prev;
      if (videoRef.current) {
        videoRef.current.muted = next;
        if (!next) videoRef.current.play().catch(() => {});
      }
      return next;
    });
  };

  const onVideoError = () => setVideoFailed(true);

  return {
    videoRef,
    wrapRef,
    videoMuted,
    videoFailed,
    toggleVideoSound,
    onVideoError,
  };
}
